import { SimpleGrid } from "@mantine/core";

import { EMPTY_VALUE } from "@/billing/constants/empty-value";
import { formatCurrency } from "@/utils/billing";

import PracticeBillingSummaryCard from "../PracticeBillingSummaryCard";

import { PRACTICE_LEDGER_SUMMARY_CARDS } from "./constants/practice-ledger";
import type { PracticeLedgerSummaryCardsProps } from "./types/ledger-ui";

export default function LedgerSummaryCards({ totals }: PracticeLedgerSummaryCardsProps) {
  return (
    <SimpleGrid spacing="md" cols={{ base: 1, sm: 2, lg: 4 }} data-testid="practice-ledger-summary">
      {PRACTICE_LEDGER_SUMMARY_CARDS.map(({ id, title, totalKey, icon, iconColor }) => (
        <PracticeBillingSummaryCard
          key={id}
          icon={icon}
          title={title}
          iconColor={iconColor}
          testId={`practice-ledger-summary-${id}`}
          value={totals ? formatCurrency(totals[totalKey]) : EMPTY_VALUE}
        />
      ))}
    </SimpleGrid>
  );
}
